import { render, staticRenderFns } from "./EventAlert.vue?vue&type=template&id=519e1c90&scoped=true"
import script from "./EventAlert.vue?vue&type=script&lang=js"
export * from "./EventAlert.vue?vue&type=script&lang=js"
import style0 from "./EventAlert.vue?vue&type=style&index=0&id=519e1c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e1c90",
  null
  
)

export default component.exports